<template>
  <Modal>
    <Modal.Title>Resubscribe</Modal.Title>
    <Modal.Body>
      <ResubscribePaymentBody
        v-model:segment="segment"
        :error-message="errorMessage"
      />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="stroke" :disabled="loading" @click="close()">
        Cancel
      </Button>
      <Button variant="primary" :loading="loading" @click="handleResubscribe">
        Resubscribe
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Modal, Button, useModal } from '@dacr/library'

import { useBillingStore } from '@/features/billing/store'
import ResubscribePaymentBody from './ResubscribePaymentBody.vue'
import { useResubscribe } from '../useResubscribe'

const { close } = useModal()
const billingStore = useBillingStore()
const { loading, errorMessage, resubscribe } = useResubscribe()

const segment = ref(
  billingStore.billing?.paymentMethod?.card ? 'current' : 'new'
)

const handleResubscribe = async () => {
  if (await resubscribe(segment.value === 'new')) close()
}
</script>
